import { z } from 'zod';

/**
 * Tính năng MỚI đang làm (anh Toàn chốt 30/10/2026): trang và API khoá bằng mật khẩu dùng thử, sidebar gắn dấu "Đang làm".
 *
 * Danh sách này là nguồn duy nhất: cổng ở máy chủ (`middleware/featurePreview.ts`), màn mở khoá và dấu ở sidebar đều đọc
 * từ đây, nên mục có mật khẩu luôn có dấu và ngược lại. Chỉ khai tính năng mới chưa nghiệm thu — KHÔNG khai lại các phân hệ
 * nhân viên đang dùng hằng ngày (cổng cũ khoá cả chúng nên đã bị gỡ 18/09/2026). Khách nghiệm thu thì xoá mục khỏi đây.
 *
 * `page`: tiền tố đường dẫn web (gồm trang con và ?query) — vắng khi chỉ khoá một phần của màn đang dùng. `apis`: tiền tố API
 * (không có `/api`).
 */
export const PREVIEW_FEATURES = {
 // YC-07 phần 1 (30/10/2026): danh mục vị trí kho và tồn theo vị trí.
 warehouseBins: { page: '/warehouse-locations', apis: ['/warehouse-bins'] },
 // Ảnh trên Quy trình P (Roary 04/11/2026). Không có `page`: màn Quy trình P đang dùng hằng ngày nên không khoá cả màn, chỉ khoá
 // phần ảnh — nút "Ảnh" mang nhãn "Đang làm" ngay tại chỗ, sidebar không gắn dấu.
 pProcessPhotos: { apis: ['/p-process/attachments'] },
 // Red PI (Roary 04/11/2026, mục 9): trang Red PI; sổ Red (cookie `hb_ledger=red`) và lập PI có tick Red cũng đòi mở khoá — kiểm ở
 // `middleware/featurePreview.ts` và service PI, vì sổ Red không có tiền tố API riêng.
 redPi: { page: '/red-pi', apis: [] },
} as const satisfies Record<string, { page?: string; apis: readonly string[] }>;
export type PreviewFeature = keyof typeof PREVIEW_FEATURES;
export const previewFeatureSchema = z.enum(Object.keys(PREVIEW_FEATURES) as [PreviewFeature, ...PreviewFeature[]]);
export const previewUnlockSchema = z.object({ password: z.string().min(1).max(200) });

export function previewFeatureFor(path: string, kind: 'page' | 'api'): PreviewFeature | undefined {
 const clean = path.split('?')[0]!.replace(/^\/api(?=\/)/, '');
 return (Object.keys(PREVIEW_FEATURES) as PreviewFeature[]).find(key => {
  const def: { page?: string; apis: readonly string[] } = PREVIEW_FEATURES[key];
  const prefixes: readonly string[] = kind === 'page' ? (def.page ? [def.page] : []) : def.apis;
  return prefixes.some(p => clean === p || clean.startsWith(p + '/'));
 });
}

export interface PreviewAccess { unlocked: boolean; configured: boolean; expiresAt: number | null }
